import { Grid, Skeleton, Tab, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TableSortLabel, Tabs, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { tabs } from 'src/components/document-management/documentation';
import emptyImg from 'src/pages/therapist-dashboard/therapist-document/image-removebg-preview.png';
import MultiSelectWithSearch from 'src/pages/therapist-dashboard/therapist-document/table-header-multiselect-search';
import { getSupervisoryAlertAction } from 'src/redux/actions/departmentDashboard';

  interface SupervisoryType {
    id: number;
    discipline: string;
    remainingVisit: number;
    status: string;
    planned10thVisit: string;
    name: string;
  }

type SortOptions = {
  sortBy: 'title' | 'therapist' | 'patientName' | 'document' | 'dueDate';
  sortDirection: 'asc' | 'desc';
};

const TenthSupervisorAlert = () => {
  const dispatch = useDispatch();
  const [pageNo, setPageNo] = useState<number>(0);
  const [rowPerPage, setRowPerPage] = useState<number>(10);
  const [selectedPatient, setSelectedPatient] = useState<any>(null);

  const [activeTab, setActiveTab] = useState<string>('PT');

  const [sortOptions, setSortOptions] = useState<SortOptions>({
    sortBy: 'dueDate',
    sortDirection: 'desc'
  });
  const onPageChange = (event: any, newPage: number) => {
    setPageNo(newPage);
  };

  const supervisorSetting = useSelector((state: any) => state.getSupervisoryAlertSettingReducer)
 

  const getListOfValues = (items: any) => {
    return items?.map((therapist: any) => therapist?.value);
  };
  const totalPatientRes = useSelector((state: any) => state.getAllPatientsReducer);



  const onRowsPerPageChange = (event: any) => {
    setPageNo(0);
    setRowPerPage(event.target.value);
  };

  const getSupervisoryAlert = useSelector((state: any) => state.getSupervisoryAlertReducer);
  useEffect(() => {

    const selectedDate = new Date();
    dispatch(getSupervisoryAlertAction({
      params: {
        today: moment(selectedDate).format('YYYY-MM-DD'),
        sortDirection: sortOptions.sortDirection,
        searchString: '',
        page: pageNo,
        pageSize: rowPerPage,
        sortBy: sortOptions.sortBy,
      },
      body: {
        discipline: activeTab,
        patientIds: selectedPatient?.length ? getListOfValues(selectedPatient) : null,
      }
    }));
  }, [pageNo, rowPerPage, sortOptions, selectedPatient, activeTab]);

  const handleSort = (key: any) => {
    const isAsc = sortOptions.sortBy === key && sortOptions.sortDirection === 'asc';
    const direction = isAsc ? 'desc' : 'asc';
    setSortOptions({ sortBy: key, sortDirection: direction });
  };

  const getAllPatientList = useMemo(() => {
    return totalPatientRes?.totalPatients.map((res: any) => {
      return {
        label: `${res?.lastName}, ${res?.firstName}`,
        value: res?.uuid,
      };
    });
  }, [totalPatientRes]);

  const handleSortMultiselect = useCallback((label: any, direction: any) => {
    if (label === 'PatientName') return setSortOptions({ sortBy: 'patientName', sortDirection: direction });
  }, []);

  const handleChangeTab = (value: string) => {
    setActiveTab(value);
    setPageNo(0);
    setRowPerPage(10);
    setSelectedPatient(null);
    setSortOptions({
      sortBy: 'dueDate',
      sortDirection: 'desc'
    });
  };

  return (
    <Stack>
      <Stack>
        <Grid display={'flex'}
          alignItems={'center'}
          marginBottom={1} >
          <Typography variant="h6">Supervision Tracking – Remaining Assistant Visits</Typography>
          <Tabs
            indicatorColor="primary"
            textColor="primary"
            value={activeTab}
            sx={{ px: 3 }}
            onChange={(e, value) => handleChangeTab(value)}
          >
            {tabs.map((tab) => (
              <Tab
                key={tab.value}
                disabled={tab.label === 'SLP' ? !supervisorSetting?.response?.SLP : false}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {tab.label}
                  </Box>
                }
                value={tab.value}
              />
            ))}
          </Tabs>
        </Grid>
      </Stack>
      <Stack mt={3}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                {/* <TableSortLabel
                  active={sortOptions.sortBy === 'patientName'}
                  direction={
                    sortOptions.sortBy === 'patientName' ? sortOptions.sortDirection : 'asc'
                  }
                  onClick={() => handleSort('patientName')}
                > */}
                  Patient
                {/* </TableSortLabel>
                <MultiSelectWithSearch
                  options={getAllPatientList}
                  pageNo={pageNo}
                  setPageNo={setPageNo}
                  handleSortMultiselect={handleSortMultiselect}
                  setAppliedValues={setSelectedPatient}
                  appliedValues={selectedPatient}
                  sortConfig={sortOptions}
                /> */}
              </TableCell>
              <TableCell>Remaining Assistant Visits</TableCell>
              <TableCell>Projected date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {getSupervisoryAlert?.loading ? <TableRow>
              <TableCell colSpan={8}>
                {Array.from({ length: 9 }).map((_, index) => (
                  <Box
                    textAlign="center"
                    key={index}
                    p={.8}
                    sx={{ minWidth: '530px', }}
                  >
                    <Typography
                      variant="h3"
                      color="initial"
                    >
                      <Skeleton animation="wave" />
                    </Typography>
                  </Box>
                ))}
              </TableCell>
            </TableRow> : !getSupervisoryAlert?.response?.content?.length ?

              <TableRow>
                <TableCell colSpan={8}>
                  <Box
                    textAlign="center"
                    p={3}
                  >
                    <img
                      src={emptyImg}
                      alt="loader"
                      style={{
                        width: 620,
                        height: 240,
                        margin: 'auto',
                        alignItems: 'center',
                        alignContent: 'center',
                        marginTop: 50,
                        display: 'block',
                      }}
                    />
                    <Typography
                      color={'text.secondary'}
                      variant="h6"
                      fontWeight={'200'}
                    >
                      No results found
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow> :
                getSupervisoryAlert?.response?.content?.map((res: SupervisoryType, index: number) => {
              return (
                <TableRow key={index} >
                  <TableCell>{res.name}</TableCell>
                  <TableCell>
                    <Stack flexDirection="row" alignItems="center" gap={1}>
                      {
                        res.remainingVisit < 0 ? (
                          <Typography variant='subtitle2' color='red'>
                            {res.remainingVisit}  (Overdue)
                          </Typography>
                        ) : res.remainingVisit == 0 ?
                            <Typography variant='subtitle2' color='#F28C28'>
                              {res.remainingVisit}  (Due Today)
                          </Typography>
                          : (
                            <>
                              {res.remainingVisit}
                            </>
                          )
                      }
                    </Stack>
                  </TableCell>
                  <TableCell>{res?.planned10thVisit ?? '-' }</TableCell>
                </TableRow>
              );
            })}



          </TableBody>
        </Table>
        {getSupervisoryAlert?.response?.content.length !== 0 && (
          <TablePagination
            component="div"
            count={getSupervisoryAlert?.response?.totalElements || 0}
            onPageChange={onPageChange}
            onRowsPerPageChange={onRowsPerPageChange}
            page={pageNo}
            rowsPerPage={rowPerPage}
            rowsPerPageOptions={[10, 20, 40]}
          />
        )}
      </Stack>
    </Stack>
  );
};

export default TenthSupervisorAlert;